<div class="sp-toolbar">
  <div class="sp-info">
    <!-- FLOORS TOTAL -->
    <p>
      {{ 'actionsToolbar.floor' | xTranslate }}
      <span> {{ totalNumberOfFloors || ('commonLabels.unknown' | xTranslate) }} </span>
    </p>
    <!-- FLOORS RENTABLE -->
    <p>
      {{ 'actionsToolbar.netRentable' | xTranslate }}:
      <span>
        {{ buildingSpaceValue != null ? (buildingSpaceValue | formatNumber) : ('commonLabels.dash' | xTranslate) }}
        {{ (buildingSpaceUOMName != null ? buildingSpaceUOMName : '') | abbrevUom }} |</span
      >

      {{ 'actionsToolbar.totalVacancy' | xTranslate }}:
      <span
        >{{ totalVacancySpace | formatNumber }}
        {{ (totalVacancySpaceUom != null ? totalVacancySpaceUom : '') | abbrevUom }} | ({{
          buildingVacancyPercent | percent
        }})</span
      >
    </p>
  </div>
  <div class="sp-info" *ngIf="!hasBrokerRole">
    <p>
      {{ 'commonLabels.pendingIssues' | xTranslate }}
    </p>
    <button (click)="onPendingIssues()" *ngIf="pendingIssues$ | async as pendingIssues">
      (
      <span>{{ pendingIssues.unknown }} {{ 'commonLabels.unknown' | xTranslate }}</span>
      <span>{{ pendingIssues.expired }} {{ 'commonLabels.expired' | xTranslate }}</span>
      )
    </button>
  </div>
  <div *ngIf="!hideActionButtons()" class="sp-info">
    <!-- Manage Floors -->
    <mat-icon
      id="e2e-manage-floors-btn"
      *ngIf="hasEditionPerms()"
      (click)="onMoreInfo()"
      svgIcon="building-info"
      [matTooltip]="'moreInfo.manageFloorsElevators' | xTranslate"
      matTooltipClass="tooltip-action-icon"
    >
    </mat-icon>

    <!-- Add new space-->
    <mat-icon
      id="e2e-add-new-space-btn"
      *ngIf="hasEditionPerms()"
      svgIcon="add"
      [matTooltip]="'recordsSearch.addNewSpace' | xTranslate"
      [matMenuTriggerFor]="menu"
      matTooltipClass="tooltip-action-icon"
    >
    </mat-icon>

    <!-- Download icon -->
    <mat-icon
      spExport
      svgIcon="exit-to-app"
      [matTooltip]="'recordsSearch.download' | xTranslate"
      matTooltipClass="tooltip-action-icon"
      *ngIf="!hasBrokerRole"
    >
    </mat-icon>

    <!-- Visualization Settings -->
    <mat-icon
      (click)="onSettings()"
      svgIcon="settings"
      [matTooltip]="'actionsToolbar.stackSettings' | xTranslate"
      matTooltipClass="tooltip-action-icon"
    >
    </mat-icon>
  </div>
</div>

<!-- ADD NEW MENU OPTIONS -->
<mat-menu #menu="matMenu">
  <button
    mat-menu-item
    class="menu-item toolbar-menu-item mat-mdc-menu-item--h-sm"
    (click)="createNewRecord.emit({ entityName: 'tenancy' })"
  >
    {{ (isTenantActive ? 'commonLabels.tenant' : 'commonLabels.lease') | xTranslate }}
  </button>
  <button
    mat-menu-item
    class="menu-item toolbar-menu-item mat-mdc-menu-item--h-sm"
    (click)="createNewRecord.emit({ entityName: 'availability' })"
  >
    {{ 'commonLabels.availability' | xTranslate }}
  </button>
  <button mat-menu-item class="menu-item toolbar-menu-item mat-mdc-menu-item--h-sm" (click)="onNewNonRentableSpace()">
    {{ 'actionsToolbar.nonRentableSpace' | xTranslate }}
  </button>
  <button
    *ngIf="isOwnerOccupiedActiveInCatalog$ | async"
    mat-menu-item
    class="menu-item toolbar-menu-item mat-mdc-menu-item--h-sm"
    (click)="createNewRecord.emit({ entityName: 'tenancy', ownerOccupied: true })"
  >
    {{ 'actionsToolbar.ownerOccupiedSpace' | xTranslate }}
  </button>
</mat-menu>
